import _ from "lodash";

/**
 * Search into the array for the needle, same as php
 *
 * @param needle
 * @returns {boolean}
 */
Array.prototype.inArray = function(needle){
    return this.indexOf(needle) !== -1;
};

/**
 * Return the first element of the array
 *
 * @return {*}
 */
Array.prototype.first = function (){
    return [...this].shift();
};

/**
 * returns the last element of the array
 *
 * @return {*}
 */
Array.prototype.last = function (){
    return [...this].pop();
};

/**
 * Returns the first element that fulfil the condition
 *
 * @param condition
 * @return {null|*}
 */
Array.prototype.firstOf = function (condition){
    if(condition === undefined)
        return this.first();

    let value = null;

    this.forEach((item, index) => {
        if(!value && condition(item, index))
            value = item;
    });

    return value;
};

/**
 * Returns the last element that fulfil the condition
 *
 * @param condition
 * @return {null|*}
 */
Array.prototype.lastOf = function (condition){
    if(condition === undefined)
        return this.last();

    let value = null;
    let reverse = [...this];

    reverse.forEach((item, index) => {
        if(!value && condition(item, index))
            value = item;
    });

    return value;
};

/**
 * Get the values of a given key.
 *
 * @param value
 * @return {*}
 */
Array.prototype.pluck = function (value){
    return this.map(item => _.get(item, value));
};

/**
 * Generates a random unique id with a prefix
 *
 * @param prefix
 * @returns {string}
 */
String.uniqueID = prefix => [
    prefix || 'id',
    Math.random().toString(16).slice(2),
].join('_');

/**
 * Check if the given value is a string
 *
 * @param value
 * @returns {boolean}
 */
String.isString = value => typeof value === 'string';
